import { IPartialOperatorBalance } from "src/@types/store-conciliation";

export interface PartialOperatorBalanceProps {
  conciliation_id?: string;
}

export type PartialOperatorColumn = {
  readonly key: keyof IPartialOperatorBalance;
  readonly label: string;
  readonly isMoney: boolean;
};

export const PARTIAL_OPERATOR_COLUMNS: readonly PartialOperatorColumn[] = [
  { key: "operator_code", label: "Resp.", isMoney: false },
  { key: "cash_register_code", label: "Caixa", isMoney: false },
  { key: "operator_name", label: "Nome", isMoney: false },
  { key: "previous_balance", label: "Sdo. Anterior", isMoney: true },
  { key: "entries", label: "Entradas", isMoney: true },
  { key: "exits", label: "Saídas", isMoney: true },
  { key: "current_balance", label: "Sdo. Atual", isMoney: true },
  { key: "money", label: "Dinheiro", isMoney: true },
  { key: "expenses", label: "Despesas", isMoney: true },
  { key: "day_result", label: "Resultado do Dia", isMoney: true },
];

export const PARTIAL_OPERATOR_LABELS = {
  emptyState: "Nenhum fechamento parcial de caixa nesta data",
  errorState: "Não foi possível carregar o saldo parcial dos operadores",
  loadingState: "Carregando saldo parcial…",
  forcedClosingBadge: "Fechado forçado",
  forcedClosingHint:
    "Caixa de operador com saldo anterior, que só a tesouraria deveria ter",
  forcedClosingLegend:
    "Fechado forçado: caixa de operador que aparece com saldo anterior, quando só a tesouraria deveria carregar saldo de um dia para o outro",
  openCashRegisterBadge: "Caixa em aberto",
  openCashRegisterHint: "Caixa ainda não fechado nesta data",
  openCashRegisterLegend:
    "Caixa em aberto: caixa que ainda não foi fechado nesta data e precisa ser fechado",
} as const;

export const PARTIAL_OPERATOR_ROW_HIGHLIGHT = {
  openCashRegister: "bg-red-100",
  forcedClosing: "bg-amber-50",
} as const;

export const DIVERGENCE_ROW_OPEN_CASH_REGISTER_HIGHLIGHT =
  "border-l-4 border-l-red-500 " +
  "[&>*:nth-child(1)]:text-red-700 [&>*:nth-child(1)]:font-semibold " +
  "[&>*:nth-child(2)]:text-red-700 [&>*:nth-child(2)]:font-semibold";

export type PartialOperatorRowMarker = {
  readonly key: string;
  readonly applies: (operator: IPartialOperatorBalance) => boolean;
  readonly badge: string;
  readonly hint: string;
  readonly legend: string;
  readonly rowClassName: string;
  readonly iconClassName: string;
  readonly legendClassName: string;
};

export const OPEN_CASH_REGISTERS_WARNING = {
  title: "Existe caixa em aberto nesta loja",
  singular:
    "A loja deixou um caixa sem fechar nesta data. Enquanto ele estiver aberto, os valores do dia ficam incompletos e a conciliação não pode ser fechada.",
  plural:
    "A loja deixou caixas sem fechar nesta data. Enquanto eles estiverem abertos, os valores do dia ficam incompletos e a conciliação não pode ser fechada.",
  codesLabelSingular: "Caixa:",
  codesLabelPlural: "Caixas:",
  instruction:
    "Peça à loja para realizar o fechamento forçado e depois use o botão Reprocessar Conciliação para atualizar esta tela.",
  acknowledge: "Entendi",
  blockedAction:
    "Há caixa em aberto nesta data. Feche o caixa na loja e reprocesse a conciliação para liberar o fechamento.",
} as const;
